// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactInfo-module--contact--1VdXG","contactItem":"ContactInfo-module--contactItem--33p8U"};